module.exports = __webpack_public_path__ + "static/media/Microsoft Surface Pro 3.395bd513.png";